// THIS UTIL IS DEPRECATED. USE APP-COMPONENT UTIL INSTEAD
function convertToMinutes() {
  var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (time.length) {
    var hours = time.split(':')[0];
    var minutes = time.split(':')[1];
    return parseInt(hours * 60, 10) + parseInt(minutes, 10);
  }
  return 0;
}
export default convertToMinutes;